<template>
<div class="tiwrap" :style="'margin-bottom:' + (mb/100) + 'rem'" @click="enterdetail(teamState)">
  <div class="tistate" :style="{'background-color':stateBg}">{{teamState}}</div>
  <div class="tiname oneline">{{info.project_name}}</div>
  <div class="tirule"><span class="tiruletxt">规格：{{info.spec_name}}</span>{{info.color_china}}</div>
  <div class="tino" v-if="type==='owner'">
    编号：{{info.project_no}}
    <span class="ticopy"
          @click.stop="rf"
          v-clipboard:copy="info.project_no"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">（复制）</span>
  </div>
  <div class="tino" v-if="type==='joiner'&&info.order_id">
    订单号：{{info.order_id}}
    <span class="ticopy"
          v-clipboard:copy="info.order_id"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">（复制）</span>
  </div>
  <div v-if="type==='owner'">
    <div class="tiinfo">
      <img class="tipeo" src="@/assets/people.png" />
      {{info.actual_quantity}}/{{info.total_quantity}}
      <div class="titime">截止日期：{{info.end_time}}</div>
    </div>
    <div class="tibtngroup">
      <button class="tibtn buttonti" @click="godown(false)">批量下载</button>
      <button v-if="teamState==='进行中'&&info.is_visible===0" class="tibtn buttonti" @click.stop="saveewm">保存二维码</button>
      <button v-if="teamState==='进行中'&&info.is_visible===0" class="tibtn buttonti"
              @click.stop="shareinfo">直接分享</button>
      <button v-if="teamState==='进行中'&&info.is_visible===1&&info.actual_quantity<info.total_quantity" class="tibtn buttonti" @click.stop="ownerphoto">拍摄证件照</button>
    </div>
  </div>
  <div v-if="type==='joiner'">
    <div class="tijoin">
      <div class="tijointime">截止日期：{{info.end_time}}</div>
      <div class="tibtn"
            v-if="info.is_order===1"
            @click.stop="gopreview">下载证件照</div>
        <div class="tibtn"
            v-if="info.is_order===1&&info.is_back===1&&teamState!=='已结束'"
            @click.stop="rephoto">重新拍摄</div>
      <div class="tibtn"
           v-if="info.is_order===0&&teamState==='进行中'"
           @click.stop="pszjz">拍摄证件照</div>
    </div>
  </div>
</div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui'
import { mapMutations } from 'vuex'
export default {
  name: 'teamitem',
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    idx: {
      type: Number,
      default: -1
    },
    mb: {
      type: Number,
      default: 16
    },
    type: {
      type: String,
      default: 'owner'
    }
  },
  methods: {
    ...mapMutations(['setMakePhotoInfo']),
    onCopy () {
      Toast({
        message: '复制成功',
        duration: 2000
      })
    },
    onError () {
      Toast({
        message: '复制失败，请重新尝试',
        duration: 2000
      })
    },
    rf () {
      return false
    },
    saveewm () {
      const { info } = this
      const { project_no } = info
      this.$bus.emit('listqrcode', project_no)
    },
    rephoto () {
      const { info } = this
      const { refund_amount, refuse_reason } = info
      const txt = refund_amount === 1 ? `您的照片因为：“${refuse_reason}”被打回，照片第一次被打回，您享有一次免费重拍同价位证件照的机会，请仔细了解拍摄需求~` : `您的照片因为：${refuse_reason}被打回，这是您第${refund_amount}次被打回，您需要重新付费拍摄~`
      MessageBox({
        title: '重新拍摄',
        message: txt,
        confirmButtonText: '重新拍摄',
        showCancelButton: true,
        cancelButtonText: '关闭'
      }).then((res) => {
        res === 'confirm' && this.tophoto()
      })
    },
    tophoto () {
      const { info } = this
      this.$emit('onJointeam', info)
    },
    shareinfo () {
      console.log('分享')
      this.godown(true)
    },
    ownerphoto () {
      const { idx } = this
      this.$emit('onTakePhoto', idx)
    },
    enterdetail (state) {
      const { type } = this
      const obj = {
        owner: () => {
          this.godown(false)
        },
        joiner: (state) => {
          this.gopreview(state)
        }
      }
      obj[type](state)
    },
    gopreview (state) {
      const { info } = this
      if (state === '已结束' && info.is_order === 0) {
        // 没有订单活动又结束
        MessageBox.alert('该活动你没有任何订单')
        return false
      }
      if (info.is_order === 0) {
        this.pszjz()
        return false
      }
      this.setMakePhotoInfo(info)
      console.log(info)
      this.$router.push({
        name: 'Joinpreview'
      })
    },
    pszjz () {
      const { info } = this
      this.$emit('onJointeam', info)
    },
    godown (needShare) {
      const { info, idx } = this
      this.$router.push({
        name: 'TeamDetail',
        params: {
          info,
          idx,
          needShare
        }
      })
    }
  },
  computed: {
    stateBg () {
      const { end_time: end, is_back: isback } = this.info
      const endTime = new Date(end).getTime()
      const nowd = new Date()
      const nowTime = new Date(nowd.getFullYear(), nowd.getMonth(), nowd.getDate()).getTime()
      let txt = nowTime > endTime ? '#E5E5EA' : '#233CFF'
      txt = isback === 1 ? '#FF6C47' : txt
      return txt
    },
    teamState () {
      const { end_time: end, is_back: isback } = this.info
      const endTime = new Date(end).getTime()
      const nowd = new Date()
      const nowTime = new Date(nowd.getFullYear(), nowd.getMonth(), nowd.getDate()).getTime()
      let txt = nowTime > endTime ? '已结束' : '进行中'
      txt = isback === 1 ? '被打回' : txt
      return txt
    }
  }
}
</script>

<style scoped>
.tiwrap{
  background-color: white;
  box-sizing: border-box;
  border-radius: .16rem;
  padding:.32rem;
  font-size: .26rem;
  color:#838485;
  position: relative;
}
.tistate{
  position: absolute;
  font-size: .26rem;
  color:white;
  padding:.08rem .24rem;
  right:0;
  top:0;
  border-top-right-radius: .16rem;
  border-bottom-left-radius: .16rem;
}
.tiname{
  font-size: .32rem;
  color:#303133;
  font-weight: bold;
  width:4.5rem;
  margin-bottom: .08rem;
}
.tirule{
  margin-bottom: .08rem;
  vertical-align: middle;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.tiruletxt{
  display: inline-block;
  border-right: .02rem solid #838485;
  padding-right: .16rem;
  margin-right: .16rem;
}
.tiball{
  width:.3rem;
  height:.3rem;
  border-radius: 50%;
  display: inline-block;
  margin-left: .16rem;
}
.tino{
  padding-bottom: .32rem;
  border-bottom: .02rem solid #E5E5EA;
  margin-bottom: .32rem;
}
.ticopy{
  font-size: .26rem;
  color:#233CFF;
  padding:.1rem;
}
.tipeo{
  width:.32rem;
  height:.32rem;
  margin-right: .16rem;
}
.tiinfo{
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color:#303133;
}
.titime{
  margin-left: .48rem;
  color:#838485;
}
.tibtngroup{
  display: flex;
  display: -webkit-flex;
  margin-top: .46rem;
  justify-content: flex-end;
}
.tibtn{
  padding:.16rem .34rem;
  box-sizing: border-box;
  border-radius: .12rem;
  border:.02rem solid #E5E5EA;
  margin-left: .16rem;
  flex-shrink: 0;
  background-color: white;
}
.tiactivebg{
  background-color: #ccc;
  color:white;
}
.tijoin{
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.tijoin .tibtn{
  padding:.16rem .22rem;
}
.tijointime{
  font-size: .24rem;
  color:#ADADAE;
  white-space: nowrap;
  flex-grow: 1;
}
.buttonti{
  height:inherit;
  line-height: initial;
  font-size: inherit;
  color:rgb(131, 132, 133);
}
</style>
